import React from 'react';
import { DEFAULT_INFO_CARDS, useDefaultCardData } from 'constants/cardDefaults';
import { graphql, useStaticQuery } from 'gatsby';
import { compact, take } from 'lodash';

import CardGroupBlock from './CardGroupBlock';
import {
  filterContentByCategory,
  filterStoriesByCategory,
  mapContentToComponent,
  mapInfoDataToComponent,
  mapStoryToComponent,
} from './cardGroupBlockUtils';

const CardGroupBlockController = ({ data }) => {
  const theme = data.block.blockFields.theme;
  const fields = data.block.blockFields.cardGroupBlock[0];
  const { heading, text, cardType, includeCtaButton, ctaButton, cardSelection, cardContent } = fields;
  const { selectedContent, selectedStories, selectedInfoCards, selectedCategory, overrideDefaultCards } = cardContent;
  const defaultBlogCards = useDefaultCardData({ cardType: 'blogs' });
  const defaultStoryCards = useDefaultCardData({ cardType: 'stories' });

  // This pulls card data for all the posts for filtering out selected data
  const postContent = useStaticQuery(graphql`
    query CardGroupBlockContent {
      allWpPost {
        nodes {
          ...GetContentCardFields
        }
      }
    }
  `);

  let cards = [];

  if (cardType === 'ContentCard') {
    if (cardSelection === 'category' && selectedCategory) {
      const content = filterContentByCategory(postContent, selectedCategory.name);
      cards = content.map(mapContentToComponent);
    } else if (cardSelection === 'manual' && selectedContent) {
      cards = selectedContent.map(mapContentToComponent);
    } else if (cardSelection === 'default') {
      cards = defaultBlogCards;
    }
  } else if (cardType === 'QuoteCard') {
    if (cardSelection === 'category' && selectedCategory) {
      const content = filterStoriesByCategory(postContent, selectedCategory.name);
      cards = content.map(mapStoryToComponent);
    } else if (cardSelection === 'manual' && selectedStories) {
      cards = selectedStories.map(mapStoryToComponent);
    } else if (cardSelection === 'default') {
      cards = defaultStoryCards;
    }
  } else if (cardType === 'InfoCard') {
    if (cardSelection === 'manual' && selectedInfoCards) {
      cards = selectedInfoCards.map(mapInfoDataToComponent);
      if (overrideDefaultCards && cards.length < 3) {
        cards = cards.concat(take(DEFAULT_INFO_CARDS, 3 - cards.length));
      }
    } else if (cardSelection === 'default') {
      cards = DEFAULT_INFO_CARDS;
    }
  }

  return (
    <CardGroupBlock
      theme={theme}
      heading={heading}
      text={text}
      cardType={cardType}
      cards={compact(cards)}
      ctaButton={includeCtaButton && ctaButton && ctaButton[0]}
    />
  );
};

export default CardGroupBlockController;
